import type { MouseEventHandler } from "react";
import { twMerge } from "tailwind-merge";
import { generateImgixUrl } from "../../utils/imageUrls";
import {
  type ImageFallbackType,
  setFallbackImage,
} from "../../utils/imageFallback";

export const ProfilePicture = ({
  logoUrl,
  name,
  size = "medium",
  onClick,
  className = "",
  fallback,
}: {
  logoUrl?: string | null;
  name?: string | null;
  size?: "small" | "medium" | "large" | "xl" | "2xl";
  onClick?: MouseEventHandler;
  className?: string;
  fallback?: ImageFallbackType;
}) => {
  const getSizeStyle = () => {
    switch (size) {
      case "medium":
        return "w-[38px] min-w-[38px] max-w-[38px] h-[38px] min-h-[38px] max-h-[38px] text-[16px]";
      case "small":
        return "w-[22px] min-w-[22px] max-w-[22px] h-[22px] min-h-[22px] max-h-[22px] text-[8px]";
      case "large":
        return "w-[50px] min-w-[50px] max-w-[50px] h-[50px] min-h-[50px] max-h-[50px] text-[20px]";
      case "xl":
        return "w-[80px] min-w-[80px] max-w-[80px] h-[80px] min-h-[80px] max-h-[80px] text-[20px]";
      case "2xl":
        return "w-[96px] min-w-[96px] max-w-[96px] h-[96px] min-h-[96px] max-h-[96px] text-[20px]";
    }
  };

  const getCharacter = (name: string | null | undefined) => {
    const lcName = name?.toLowerCase();
    if (lcName && lcName.startsWith("the "))
      return lcName.split("the ")[1]?.charAt(0).toUpperCase();
    return lcName?.charAt(0).toUpperCase();
  };

  const getImageHeight = () => {
    switch (size) {
      case "2xl":
        return 150;
      default:
        return 100;
    }
  };

  const image = setFallbackImage({ img: logoUrl, fallback: fallback });
  return (
    <div
      onClick={onClick}
      style={{
        ...(image
          ? {
              backgroundImage: `url("${generateImgixUrl(image, { compress: true, height: getImageHeight() })}")`,
            }
          : {}),
        ...(onClick
          ? {
              cursor: "pointer",
            }
          : {}),
      }}
      className={twMerge(
        "flex items-center justify-center rounded-full bg-slate-500 bg-cover bg-center text-white print:hidden",
        getSizeStyle(),
        className,
      )}
    >
      {!image && getCharacter(name)}
    </div>
  );
};
